/**
 * Asset path helper — resolves public/ files relative to index.html.
 *
 * WHY: sound.ts / SplashScreen used absolute paths like `/sounds/x.mp3`.
 * Those work on Play Store (capacitor://localhost root) and `vite dev`,
 * but BREAK inside the Y8 iframe / Y8 storage where the game lives under
 * a sub-path (`/games/.../index.html` → `/sounds` = domain root = 404).
 * `./sounds/x.mp3` resolves against the page URL, so it works everywhere:
 * Play Store, local file, and Y8 zip — with zero behavior change on phones.
 */
export function asset(p: string): string {
  const clean = p.replace(/^\.\//, "").replace(/^\//, "");
  const base: string =
    (import.meta as unknown as { env?: { BASE_URL?: string } }).env?.BASE_URL ??
    "./";
  const prefix = base.endsWith("/") ? base : `${base}/`;
  return `${prefix}${clean}`;
}
